document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".flavor-top").forEach(item => {
    item.addEventListener("click", function () {
      const parent = this.parentElement;
      const content = parent.querySelector(".flavor-content");

      const isOpen = content.style.display === "block";

      document.querySelectorAll(".flavor-content").forEach(el => el.style.display = "none");

      if (!isOpen) {
        content.style.display = "block";
      }
    });
  });
});



  document.addEventListener('click', function(e) {
    const clicked = e.target.closest('.flavor-left');
    if (!clicked) return;

    const isActive = clicked.classList.contains('active');

    // Remove active from all
    document.querySelectorAll('.flavor-left.active')
      .forEach(el => el.classList.remove('active'));

    // Toggle: only add if it wasn't already active
    if (!isActive) {
      clicked.classList.add('active');
    }
  });

